//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import _          from 'lodash';
import { select } from 'redux-saga/effects';

function* selectFromState(...path) {
    return yield select((state) => _.get(state, path));
}

function* selectFromStateWithCallback(stateCallback, ...path) {
    return yield select((state) => {
        const scopeOfState = _.get(state, path);

        return stateCallback(scopeOfState);
    });
}

function* selectFromParentStateWithCallback(stateCallback) {
    return yield select((state) => {
        return stateCallback(state);
    });
}

function* getState() {
    return yield select((state) => state);
}

export default {
    getState,
    selectFromParentStateWithCallback,
    selectFromState,
    selectFromStateWithCallback,
};
